import {useLoaderData} from "react-router";
import {hasPermission} from "../utils/permission-matcher.js";

const useHasPermission = () => {
    const loaderData = useLoaderData();

    return (permission) => hasPermission(loaderData?.permissions, permission);
};

export default useHasPermission;